/**
 * release-object-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link ReleaseObjectRequest} to tell the server it is
 * finished with an object (for now, a Subject Context) and the server can stop
 * holding onto the associated releases.
 */
export class ReleaseObjectRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_RELEASE_OBJECT;
	public static tag : MessageTag = MessageTag.REQ_RELEASE_OBJECT;

  /**
   * Construct a new {@link ReleaseObjectRequest}.
   */
  constructor (public objectId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/release-object-request.ts